import { Ref, ref } from "vue";
import { MstSyouninGroupsService } from "@/service/MstSyouninGroupsService";
import { BaseOptionWithoutCode, OptionWithAnnotation } from "@/types/Option";
import { SyouninGroupOptions } from "@/types/SyouninGroup";

export function useSyouninGroupOptions() {
  const srv = new MstSyouninGroupsService();
  const syouninGroupOptions: Ref<SyouninGroupOptions | null> = ref(null)

  const getAllSyouninGroupOptions = async () => {
    const opt = await srv.getAllOptions()
    syouninGroupOptions.value = opt
  }

  // Option（val/label）のlabel文字列を取得
  const getSyouninGroupOptionsLabel = (options: BaseOptionWithoutCode[], val: number | null | undefined) => {
    if (val === null || typeof val === 'undefined') {
      return '-'
    }
    const label = options.find((opt) => opt.val === val)?.label;
    if (typeof label === 'undefined') {
      return '-'
    } else {
      return label
    }
  }
  return {
    syouninGroupOptions,
    getAllSyouninGroupOptions,
    getSyouninGroupOptionsLabel
  }
}
